export const payload = {
  receiveMutation: 'RECEIVE_ACCOUNTGROUPS',
  receivingMutation: 'RECEIVING_ACCOUNTGROUPS',
  receiveMetadataMutation: 'RECEIVE_ACCOUNTGROUP_METADATA',
  receiveFailureMutation: 'RECEIVE_ACCOUNTGROUP_FAILURE',
  savingMutation: 'SAVING_ACCOUNTGROUP',
  saveFailureMutation: 'SAVING_ACCOUNTGROUP_FAILURE',
  incrementMutation: 'INCREMENT_ACCOUNTGROUP_COUNT',
  updatingMutation: 'UPDATING_ACCOUNTGROUP',
  updateFailureMutation: 'UPDATING_ACCOUNTGROUP_FAILURE',
  deleteMutation: 'DELETE_ACCOUNTGROUP',
  deletingMutation: 'DELETING_ACCOUNTGROUP',
  deleteFailureMutation: 'DELETING_ACCOUNTGROUP_FAILURE',
  resetMetaMutation: 'RESET_ACCOUNTGROUP_META',
  clearMutation: 'CLEAR_ACCOUNTGROUP_STATE',
  moduleName: 'accountgroup',
  endpoint: 'accountgroup',
  searchableFields: ['code', 'description', 'sortorder']
}

